import { TemplateType } from './task';

export enum MediaType {
  Image = 'image',
  Video = 'video',
}

export interface Media {
  type: MediaType;
  content: string;
}

export enum ShareVideoSourceType {
  Default = 0,
  SDKInWeChat = 1,
  Tutorial = 2,
}

export enum SharePlatform {
  Moments = 'moments',
  Channel = 'channel',
}

export interface ExportShareInfo {
  templateId: string; // 模版id
  templateType?: TemplateType; // 模版类型
  taskId: number; // 活动任务id
  videoSourceType?: ShareVideoSourceType; // 视频来源，默认ShareVideoSourceType.Tutorial
  autoSharePlatform?: SharePlatform; // 自动分享的平台，默认不分享
  musicId?: string; // 音乐id，默认无
}
